import React, { SVGAttributes } from 'react';

/** justify-content: space-around — equal space around each item (half at edges) */
export default ({ color = '#FFF', ...props }: SVGAttributes<SVGElement> & { color?: string }) => (
	<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
		<path d="M3 5V19M21 5V19" stroke={color} strokeWidth="1" strokeOpacity="0.6" />
		<rect x="5.5" y="7" width="3" height="10" rx="1" ry="1" fill={color} />
		<rect x="10.5" y="7" width="3" height="10" rx="1" ry="1" fill={color} />
		<rect x="15.5" y="7" width="3" height="10" rx="1" ry="1" fill={color} />
	</svg>
);
